import OutlineService from "./outline/services/OutlineService";
import PdfDocumentService from "./pdfDocument/services/PdfDocumentService";

(window as any).WemogyPdfJsExtensions = {
	OutlineService,
	PdfDocumentService
};

console.log("WemogyPdfJsExtensions loaded");
